import { Fragment } from 'react'
import clx from 'classnames'
import _ from 'lodash'
import styles from './Sort.css'

const Sort = props => {
  const { id, options, sortType, onChange, margin = true } = props
  return (
    <div
      className={clx(
        styles.sortByRadioGroup,
        { [styles.margin]: margin }
      )}
    >
      排列：
      {
        options.map((option, index) => {
          const {
            value,
            text
          } = option
          const currentValue = `${id}-${value}`
          return (
            <Fragment key={index}>
              <input
                key={`input_${currentValue}`}
                id={currentValue}
                name={`${id}-sort-group`}
                type='radio'
                checked={value === sortType}
                value={value}
                onChange={onChange}
              />
              <label
                htmlFor={currentValue}
                key={`text_${currentValue}`}
              >
                {text}
              </label>
              {
                index !== _.size(options) - 1 && (
                  <label
                    className={styles.divider}
                    key={`divider_${currentValue}`}
                  >
                    |
                  </label>
                )}
            </Fragment>
          )
        })
      }
    </div>
  )
}

export default Sort
